import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AventuraService } from 'src/app/services/api/aventura.service';
import Swal from 'sweetalert2';
import { DialogInventarioAventuraComponent } from '../inventario/dialog-inventario-aventura/dialog-inventario-aventura.component';
import { DialogListaEquiposComponent } from './dialog-lista-equipos/dialog-lista-equipos.component';

@Component({
  selector: 'app-lista-equipos',
  templateUrl: './lista-equipos.component.html',
  styleUrls: ['./lista-equipos.component.css']
})
export class ListaEquiposComponent implements OnInit {

  articulos: any = [];
  equipo: any

  displayedColumns: string[] = [
    'codigo',
    'nombre',
    'marca',
    'modelo',
    'talla',
    'categoria',
    'modificar',
    'eliminar'
  ];

  dataSource: any;
  loading: boolean = true;

  selectNombre: string | null = null;
  selectMarca: string | null = null;
  selectModelo: string | null = null;
  selectTalla: string | null = null;
  selectCategoria: string | null = null;
  selectEstado: string | null = null;

  arrayNombres: any = [];
  arrayMarcas: any = [];
  arrayModelos: any = [];
  arrayTallas: any = [];
  arrayCategorias: any = [];
  arrayEstados: any = [];


  // @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }


  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private cdr: ChangeDetectorRef,public dialog: MatDialog, private almacenService: AventuraService) {
  }

  ngOnInit() {
    this.getAllEquipos();
  }

  getAllEquipos() {
    this.almacenService.getAllEquipos().subscribe((response) => {
      this.articulos = response.getAllEquipos;

      this.articulos = this.articulos.sort((a: { nombre: string; }, b: { nombre: any; }) => a.nombre.localeCompare(b.nombre));

      const nombre = this.articulos.filter((item: any) => item.nombre !== '' && item.nombre !== null).map((item: any) => (item.nombre))
      const marca = this.articulos.filter((item: any) => item.marca !== '' && item.marca !== null).map((item: any) => (item.marca))
      const modelo = this.articulos.filter((item: any) => item.modelo !== '' && item.modelo !== null).map((item: any) => (item.modelo))
      const talla = this.articulos.filter((item: any) => item.talla !== '' && item.talla !== null).map((item: any) => (item.talla))
      const categoria = this.articulos.filter((item: any) => item.categoria !== '' && item.categoria !== null).map((item: any) => (item.categoria))
    
      this.arrayNombres = [...new Set(nombre)]
      this.arrayMarcas = [...new Set(marca)]
      this.arrayModelos = [...new Set(modelo)]
      this.arrayTallas = [...new Set(talla)]
      this.arrayCategorias = [...new Set(categoria)]

      this.dataSource = new MatTableDataSource(this.articulos);
      this.cdr.detectChanges();
      this.dataSource.paginator = this.paginator
      this.loading=false
      return response;
    });

  }

  getEquipoById(id:any) {
    this.almacenService.getEquipo(id).subscribe((response) => {
      this.equipo = response.getEquipo;
      return this.equipo;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogModify(i: any): void {

    let dialogConfig = new MatDialogConfig();
    console.log(i)
    this.almacenService.getEquipo(i).subscribe((response) => {
      this.equipo = response.getEquipo;

      console.log(this.equipo)
      dialogConfig.data = {
        id:this.equipo.id,
        codigo:this.equipo.codigo,
        nombre: this.equipo.nombre,
        marca: this.equipo.marca,
        modelo: this.equipo.modelo,
        talla: this.equipo.talla,
        categoria: this.equipo.categoria,
        title: "Modificar Equipo",
        estado:1
      };
      dialogConfig.width = "40rem";
      dialogConfig.height="500px";

      let dialogRef = this.dialog.open(DialogListaEquiposComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        console.log("closed");
        console.log(result);
        if(result==1){
          this.getAllEquipos();
        }
      });
    });


  }

  openDialogAdd(): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      nombre:"",
      marca:"",
      modelo:"",
      categoria:"",
      talla:"",
      title:"Agregar Equipo",
      estado:2
    };
    dialogConfig.width="40rem";
    dialogConfig.height="500px";

    let dialogRef = this.dialog.open(DialogListaEquiposComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log("closed");
      console.log(result);
      if(result==1){
        this.getAllEquipos();
      }
    });
  }


  deleteEquipo(equipo: any,i:number): void {

    Swal.fire({
      title: 'Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {

        console.log(equipo,i)
        this.almacenService.deleteEquipo(equipo.id).subscribe((data: any)=>{
          console.log(data);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'El registro se eliminó satisfactoriamente.',
            showConfirmButton: false,
            timer: 4000
          });
          this.getAllEquipos();
       /*    this.dataSource.data.splice(i, 1);
          this.dataSource._updateChangeSubscription(); */
        })

      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("false");
      }
    })

  }

  applyFilterSelect() {

    let dataNew: any = this.articulos
    if (this.selectNombre) {
      dataNew = dataNew?.filter((item: any) => item.nombre === this.selectNombre)

    }
    if (this.selectMarca) {
      dataNew = dataNew?.filter((item: any) => item.marca=== this.selectMarca)

    } if (this.selectModelo) {
      dataNew = dataNew?.filter((item: any) => item.modelo === this.selectModelo)

    } if (this.selectTalla) {
      dataNew = dataNew?.filter((item: any) => item.talla === this.selectTalla)

    } if (this.selectCategoria) {
      dataNew = dataNew?.filter((item: any) => item.categoria === this.selectCategoria)

    } 

    this.dataSource.data = dataNew

  }

}
